import React from 'react'
import { useSearchParams } from 'react-router-dom';

const LinkIssues = () => {
  const [searchParam] = useSearchParams();
  const status = searchParam.get('errorCode');

  const getErrorStatus = () => {
    if(status === 'INVALID_PAYMENT_LINK') return 'Payment link is invalid.'
    if(status === 'EXPIRED_PAYMENT_LINK') return 'Payment link has expired.'
    else return 'Invalid URL';
  }

  return (
    <div className="flex flex-col items-center justify-center m-auto">
      <div id="logo" className="flex items-center justify-center h-1/6 mt-5 ">
        <img src="/logo.svg" alt="NHL Logo" />
      </div>
      <div className="flex items-center justify-center fixed top-0 h-full px-2">
        <p className="text-red-700 h-10">{getErrorStatus()}</p>
      </div>
    </div>
  );
}

export default LinkIssues